import React, { useEffect, useState } from 'react';
import { getDatabase, ref, onValue, remove } from 'firebase/database';
import { app } from '../firbase';
import '../styles/AdminDashboard.css';
import { useLocation, useNavigate } from 'react-router-dom';
import AdminBookingData from '../pages/AdminBookingData';
import TableTracker from '../pages/TableTracker';

const AdminDashboard = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);
  const [passwordInput, setPasswordInput] = useState('');
  const [bookings, setBookings] = useState({});
  const [searchQuery, setSearchQuery] = useState('');
  const [activeTab, setActiveTab] = useState('tracker');

  const adminPassword = 'snookeradmin123';

  const handleLogin = () => {
    if (passwordInput === adminPassword) {
      setAuthenticated(true);
    } else {
      alert('Incorrect admin password!');
      navigate('/', { state: location.state });
    }
  };

  useEffect(() => {
    // if (authenticated) {
      const db = getDatabase(app);
      const bookingsRef = ref(db, 'bookings');
      onValue(bookingsRef, (snapshot) => {
        const data = snapshot.val() || {};
        const groupedByDate = {};
        Object.entries(data).forEach(([key, value]) => {
          const date = value.date;
          if (!groupedByDate[date]) groupedByDate[date] = [];
          groupedByDate[date].push({ id: key, ...value });
        });
        setBookings(groupedByDate);
      });
    }
   );
  //  [authenticated]);

  const handleDelete = (id) => {
    if (window.confirm('Are you sure you want to delete this booking?')) {
      remove(ref(getDatabase(app), `bookings/${id}`));
    }
  };

  if (!authenticated) {
    return (
      <div className="admin-login">
        <h2>Admin Login</h2>
        <input
          type="password"
          placeholder="Enter admin password"
          value={passwordInput}
          onChange={(e) => setPasswordInput(e.target.value)}
        />
        <button onClick={handleLogin}>Login</button>
      </div>
    );
  }

  return (
    <div className="admin-container">
      <h2>Admin Dashboard</h2>
      <div className="tab-buttons">
        <button
          onClick={() => setActiveTab('tracker')}
          className={activeTab === 'tracker' ? 'active' : ''}
        >
          Table Tracker
        </button>
        <button
          onClick={() => setActiveTab('bookings')}
          className={activeTab === 'bookings' ? 'active' : ''}
        >
          Bookings
        </button>
      </div>

       {activeTab === 'bookings' && (
        <AdminBookingData
          bookings={bookings}
          searchQuery={searchQuery}
          setSearchQuery={setSearchQuery}
          handleDelete={handleDelete}
        />
      )}

      {activeTab === 'tracker' && <TableTracker bookings={bookings} />} 
    </div>
  );
};

export default AdminDashboard;
